const materials = [
  { name: 'Ferro', img: 'iron scrap metal pile' },
  { name: 'Alumínio', img: 'aluminum cans scrap' },
  { name: 'Cobre', img: 'copper wire scrap' },
  { name: 'Latão', img: 'brass fittings scrap' },
  { name: 'Aço Inox', img: 'stainless steel scrap' },
  { name: 'Baterias', img: 'car batteries scrap' },
  { name: 'Motores', img: 'electric motors scrap' },
  { name: 'Eletrônicos', img: 'electronic circuit boards scrap' },
]

export const MaterialsSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in p-4">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6 border-b-2 border-gray-400 pb-2">
        Tipos de Materiais
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 overflow-y-auto pb-4">
        {materials.map((item) => (
          <div
            key={item.name}
            className="retro-bevel-outset p-2 bg-gray-100 flex flex-col hover:bg-white transition-colors cursor-pointer group"
          >
            <div className="aspect-square w-full retro-bevel-inset bg-black mb-2 overflow-hidden">
              <img
                src={`https://img.usecurling.com/p/200/200?q=${item.img}&dpr=2`}
                alt={item.name}
                className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-300"
              />
            </div>
            <span className="text-center font-serif font-bold text-gray-800 text-sm md:text-base">
              {item.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
